import { Component } from '@angular/core';

@Component({
  selector: 'app-product-new-arrival-descriptions',
  imports: [],
  templateUrl: './product-new-arrival-descriptions.html',
  styleUrl: './product-new-arrival-descriptions.scss'
})
export class ProductNewArrivalDescriptions {

}
